import React, { Fragment } from "react";
import { Popover, Transition } from '@headlessui/react'

function PopoverMenu({ button, panel, btnClass = "" }) {

  return (
    <Popover className="md:relative place-items-center grid grid-rows-1">
      {() => (
        <>
          <Popover.Button className={`${btnClass} block text-gray-600`}>
            {button}
          </Popover.Button>

          <Popover.Overlay className="opacity-30 fixed md:relative bg-gray-800 md:bg-transparent transition inset-0 z-10"/>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-100"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
            >
                
            <Popover.Panel className="origin-top-right absolute z-10 rounded-md border md:top-12 right-0 border-gray-200 left-0 top-0 md:left-auto w-auto shadow-xl bg-white">
              <div className="flex items-center custom-container py-3 justify-between md:hidden">
                <img 
                  className="w-32 h-11 inline-block"
                  src="/assets/images/castos-logo.svg"
                  alt="Castos - Podcast Hosting and Analytics"
                />
                {/* Close button inside popover panel on mobile view */}
                <Popover.Button className="text-lg rounded-md p-2 btn-ghost text-gray-600">
                  <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </Popover.Button>
              </div>
              {panel}
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}

export default PopoverMenu;
